import React, { useState, useEffect, useRef } from 'react';
import { UploadOutlined } from '@ant-design/icons';

// import { Timeline, DataSet } from 'vis-timeline/standalone';
import { DraggableModal } from 'src/app/components';
import 'src/app/popup.scss';
import styles from 'src/app/components/FMMAndPPMTabs/IncidentAndTaskTab/IncidentAndTask.module.scss';
import moment from 'moment';

import { attachmentHelper } from 'src/app/helpers';

import { statusHelper } from 'src/app/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { errorLocals } from 'src/locals';
import { contentsActions } from 'src/app/redux/actions';
import { incidentService, logsService, trainingObjectiveOfOntologyService, taskService } from 'src/app/services';
import { IncidentDataType, IncidentResultType } from 'src/types/services/incident-service.type';
import IncidentFolderForm from 'src/app/components/Forms/IncidentFolderAndWorkPackageForm/incidentFolderAndWorkPackageForm';
import { IncidentFolderResultType } from 'src/types/services/incident-folder-service.type';
import { TrainingObjectiveDataType } from 'src/types/services/objective-service.type';
import { OntologyEnum } from 'src/enums/ontology.enum';
import TrainingObjectiveForm from '../objectiveForm/objectiveForm';
import FileTable from '../../FileTable/fileTable';
import { FileTableType, IncidentFormType } from './incidentAndTaskForm.config';
import { MapUnit } from 'src/types/unit.type';
import { flowOMMEnums } from 'src/enums/flow.enum';
import { displaySuccessStatusMessage } from 'src/app/helpers/status.helper';
import { transactionForSelectList } from 'src/app/helpers/statusAndTransaction.helper';
import { generateFormNumber } from 'src/app/helpers/formNumberGenerator';

import { WorkPackageResultType } from 'src/types/services/ppm/work-package-service.type';
import Logs from '../../Logs/Logs';
import { LogsData } from '../../Logs/logs.config';

import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import { useTranslation } from 'react-i18next';
import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';
import { useUsers } from 'src/app/context/UserContext';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button';
import Select from 'antd/es/select';

const { TextArea } = Input;

interface DefaultData {
  id: string;
  eventId: string;
  folderNumberId: string;
  number: string;
  name: string;
  units: string[];
  primaryTrainingObjectiveId?: string;
  secondaryTrainingObjective?: string[];
  ccrIds?: string[];
  ttIds?: string[];
  startDateTimeGroup?: Date | undefined;
  endDateTimeGroup?: Date | undefined;
  relatedAudienceEntities: string[];
  relatedAudienceProcesses: string[];
  scenarioConditions: string;
  scenarioConditionStatus: string;
  milConditions: string;
  milConditionStatus: string;
  description: string;
  log: string;
  comment: string;
  attachments: string[];
}

const IncidentForm: React.FC<IncidentFormType> = ({
  onClickOpen,
  setOnClickOpen,
  setEditModal,
  incidentForm,
  // incidentNumber,
  kanban,
}) => {
  const { t } = useTranslation();

  const { eventName } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const defaultIncidentFolderData = {
    id: '',
    eventId: '',
    incidentFolderNumber: '',
    incidentFolderName: '',
    incidentFolderManagerId: '',
    description: '',
    log: [],
    comment: '',
    attachments: [],
  };

  const defaultWorkPackageData = {
    id: '',
    eventId: '',
    workPackageNumber: '',
    workPackageName: '',
    workPackageManagerId: '',
    description: '',
    log: [],
    comment: '',
    attachments: [],
    projectId: '',
  };

  const commonData: Omit<
    DefaultData,
    'primaryTrainingObjectiveId' | 'secondaryTrainingObjective' | 'ccrIds' | 'ttIds'
  > = {
    id: '',
    eventId: eventName,
    folderNumberId: '',
    number: '',
    name: '',
    units: [],
    relatedAudienceEntities: [],
    relatedAudienceProcesses: [],
    scenarioConditions: '',
    scenarioConditionStatus: '',
    milConditions: '',
    milConditionStatus: '',
    description: '',
    log: '',
    comment: '',
    attachments: [],
  };

  const defaultIncidentData: DefaultData = {
    ...commonData,
    primaryTrainingObjectiveId: '',
    secondaryTrainingObjective: [],
  };

  const defaultTaskData: DefaultData = {
    ...commonData,
    ccrIds: [],
    ttIds: [],
  };
  const { configurationChangeRequestList } = useSelector(
    (state: reduxRootTypes.RootStateType) => state.configurationChangeRequestState,
  );
  const { troubleTicketList } = useSelector((state: reduxRootTypes.RootStateType) => state.troubleTicketState);

  const initialList = [
    ...configurationChangeRequestList.map((obj) => ({
      id: obj.id,
      ccrId: obj.ccrId,
      name: obj.ccr,
    })),
    ...troubleTicketList.map((obj) => ({
      id: obj.id,
      ttId: obj.troubleTicketId,
      name: obj.troubleTicketName,
    })),
  ];

  const initialValues = setEditModal
    ? {
        ...incidentForm,

        units: incidentForm.units.map((value: string | MapUnit | bigint) => {
          return (value as MapUnit).kisaIsim;
        }),
      }
    : {
        ...incidentForm,
      };

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const fileInputRef = useRef<any>();

  const { preferredLanguage } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  const { incidentList } = useSelector((state: reduxRootTypes.RootStateType) => state.incidentState);
  const { commands } = useSelector((state: reduxRootTypes.RootStateType) => state.contentState);
  const { ontologies } = useSelector((state: reduxRootTypes.RootStateType) => state.ontologyState);
  const { trainingObjectiveList } = useSelector((state: reduxRootTypes.RootStateType) => state.trainingObjectiveState);
  const { incidentFolderList } = useSelector((state: reduxRootTypes.RootStateType) => state.incidentFolderState);
  const { workPackageList } = useSelector((state: reduxRootTypes.RootStateType) => state.workPackageState);
  const { actionList } = useSelector((state: reduxRootTypes.RootStateType) => state.actionState);
  const { stateNodeList } = useSelector((state: reduxRootTypes.RootStateType) => state.stateFlowState);
  const { units } = useSelector((state: reduxRootTypes.RootStateType) => state.unitsState);
  const { fieldsList } = useSelector((state: reduxRootTypes.RootStateType) => state.fieldsState);
  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { transactionList } = useSelector((state: reduxRootTypes.RootStateType) => state.transactionState);

  const [addIncidentModal, setAddIncidentModal] = useState<boolean>(false);
  const [addIncidentFolderModal, setAddIncidentFolderModal] = useState<boolean>(false);
  const [addWorkPackageModal, setAddWorkPackageModal] = useState<boolean>(false);
  // const [mapModal, setMapModal] = useState<boolean>(false);
  const [initialCcrTtList, setInitialCcrTtList] = useState<any[]>(initialList);
  const [ccrTtList, setCcrTtList] = useState<any[]>(initialList);

  const [addTrainigObjectiveModal, setAddTrainigObjectiveModal] = useState<boolean>(false);
  const [modalInEditMode, setModalInEditMode] = useState<boolean>(false);

  const [attachments, setAttachments] = useState<any[]>(incidentForm.attachments);
  const [deletedStringAttachments, setDeletedStringAttachments] = useState<string[]>([]);
  const [generatedAttachsForFileTable, setGeneratedAttachsForFileTable] = useState<FileTableType[]>([]);
  const [possibleCommandIds, setpossibleCommandIds] = useState<number[]>([]);
  const [replacedImageIndexes, setReplacedImageIndexes] = useState<number[]>([]);
  const [incidentListAllData, setIncidentAllData] = useState<IncidentResultType[]>([]);
  // const [incidentDataInForm, setIncidentDataInForm] = useState<IncidentDataType>(incidentForm || defaultIncidentData);
  const [incidentFolderDataForm, setIncidentFolderDataForm] =
    useState<IncidentFolderResultType>(defaultIncidentFolderData);
  const [workPackageDataForm, setWorkPackageDataForm] = useState<WorkPackageResultType>(defaultWorkPackageData);
  const [trainingObjectiveDataForm, setTrainingObjectiveDataForm] = useState<TrainingObjectiveDataType>();
  const [fieldsId, setFieldsId] = useState<any[]>([]);
  const [logsData, setLogsData] = useState<LogsData[]>([]);
  const [prevValues, setPrevValues] = useState(initialValues);
  const [notIncludedActionIds, setNotIncludedActionIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [incidentName, setIncidentName] = useState('');

  useEffect(() => {
    if (incidentForm && setEditModal && kanban) {
      const primaryRequirementId = form.getFieldValue('primaryRequirementId');

      const secondaryRequirementsWithoutPrimary = ccrTtList.filter((obj) => obj.id !== primaryRequirementId);

      setCcrTtList(secondaryRequirementsWithoutPrimary);
    }
  }, [setEditModal]);

  useEffect(() => {
    incidentForm && setIncidentName((incidentForm as IncidentDataType).incidentName || '');
  }, [incidentForm]);

  const { usersList } = useUsers();

  useEffect(() => {
    if (!incidentForm) return;

    form.setFieldsValue(incidentForm);
  }, [incidentForm]);

  const handleClickIncidentFolder = () => {
    if (!kanban) {
      setAddIncidentFolderModal(true);
    } else {
      setAddWorkPackageModal(true);
    }
    setModalInEditMode(false);
  };

  const handleClickTrainigObjective = () => {
    setAddTrainigObjectiveModal(true);
    setModalInEditMode(false);
  };

  const handlePrimaryTOChange = async (value: string, allValues: any) => {
    const foundTO = trainingObjectiveList.find((to) => to.id === value);
    if (!foundTO) return;
    const {
      data: { rows: relatedOntologies },
    } = await trainingObjectiveOfOntologyService.lookupTrainingObjectiveOfOntology({ trainingObjectiveIds: [value] });
    const entities: (string | undefined)[] = [];
    const processes: (string | undefined)[] = [];
    ontologies
      .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Player_Audience_Entity)
      .forEach((obj) => {
        if (relatedOntologies.some((item) => item.ontologyId === obj.id)) {
          entities.push(obj.id);
        }
      });
    ontologies
      .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Training_Audience_Process)
      .forEach((obj) => {
        if (relatedOntologies.some((item) => item.ontologyId === obj.id)) {
          processes.push(obj.id);
        }
      });
    form.setFieldsValue({
      ...allValues,
      primaryTrainingObjectiveId: value,
      milConditions: foundTO.milConditions,
      milConditionStatus: foundTO.milConditionStatus,
      scenarioConditions: foundTO.scenarioConditions,
      scenarioConditionStatus: foundTO.scenarioConditionStatus,
      relatedAudienceEntities: entities,
      relatedAudienceProcesses: processes,
    });
    const newMilState = stateNodeList.find((node) => node.id === foundTO.milConditionStatus);
    const newScenarioState = stateNodeList.find((node) => node.id === foundTO.scenarioConditionStatus);
    setAllToStateName([
      {
        id: newMilState?.id,
        stateName: newMilState?.stateName,
        enum: newMilState?.flowChartType,
      },
      {
        id: newScenarioState?.id,
        stateName: newScenarioState?.stateName,
        enum: newScenarioState?.flowChartType,
      },
    ]);
  };

  useEffect(() => {
    const relatedActions = actionList.filter((action) => action.incidentNumberId === incidentForm.id);

    let possibleCommandIds: number[] = [];

    relatedActions.forEach((action) => {
      action.emir && possibleCommandIds.push(Number([...action.emir]));
    });

    if (incidentForm.units.length) {
      const unitIds = incidentForm.units.map((unit) => {
        if (typeof unit === 'string') {
          return unit;
        } else {
          return (unit as MapUnit).kisaIsim;
        }
      });

      unitIds.forEach((unitId: string) =>
        commands.forEach((command) => {
          if (command.emirIcerigi?.unitId > 0 && command.emirIcerigi?.unitKisaIsim === unitId) {
            possibleCommandIds.push(command.id);
          }
        }),
      );
    }

    setpossibleCommandIds(possibleCommandIds);
  }, [actionList, incidentForm]);

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.incidentName || changedValues.incidentName === '') {
      setIncidentName(changedValues.incidentName);
    }

    const relatedActions = actionList.filter((action) => action.incidentNumberId === incidentForm.id);

    const changedKey = Object.keys(changedValues)[0];

    if (changedKey === 'units') {
      const oldUnits = prevValues.units || [];
      const newUnits = allValues.units || [];

      const removedUnits = (oldUnits as string[]).filter((x) => !newUnits.includes(x));

      const { units: unitIds } = changedValues;

      const notIncludedActions = relatedActions.filter(
        (action) => action.units && action.units.some((unit) => removedUnits.includes(unit)),
      );

      setNotIncludedActionIds(notIncludedActions.map((action) => action.id));

      let possibleCommandIds: number[] = [];

      unitIds.forEach((unitId: string) =>
        commands.forEach((command) => {
          if (command.emirIcerigi?.unitId > 0 && command.emirIcerigi?.unitKisaIsim === unitId) {
            possibleCommandIds.push(command.id);
          }
        }),
      );

      setpossibleCommandIds(possibleCommandIds);
    }

    setPrevValues(allValues);

    if (changedValues.primaryRequirementId) {
      form.setFieldsValue({ requirements: [] });
      const primaryRequirementObj = initialCcrTtList.find((obj) => obj.id === changedValues.primaryRequirementId);
      if (primaryRequirementObj) {
        const updatedList = initialCcrTtList.filter((obj) => obj.id !== primaryRequirementObj.id);
        setCcrTtList(updatedList);
      }
    }

    for (const [key, value] of Object.entries(changedValues)) {
      if (key === 'primaryTrainingObjectiveId') {
        handlePrimaryTOChange(value as string, allValues);
      }
      if (key === 'incidentFolderNumberId') {
        const filteredIncidents = incidentList.filter((obj) => obj.incidentFolderNumberId === (value as string));
        form.setFields([{ name: 'incidentNumber', value: generateFormNumber(filteredIncidents, 'incidentNumber') }]);
      }
    }
  };

  const [allToStateName, setAllToStateName] = useState<
    { id: string | undefined; stateName: string | undefined; enum?: number }[]
  >([]);

  const fillExistState = () => {
    const allStates: any[] = [];
    const existMil = form.getFieldValue('milConditionStatus');
    const existScenario = form.getFieldValue('scenarioConditionStatus');
    const existMilState = stateNodeList.find((x) => x.id === existMil);
    const existScenarioState = stateNodeList.find((x) => x.id === existScenario);
    if (existMilState) {
      allStates.push({
        id: existMilState.id,
        stateName: existMilState.stateName,
        enum: existMilState.flowChartType,
      });
    }
    if (existScenarioState) {
      allStates.push({
        id: existScenarioState.id,
        stateName: existScenarioState.stateName,
        enum: existScenarioState.flowChartType,
      });
    }
    setAllToStateName(allStates);
  };

  useEffect(() => {
    fillExistState();
  }, []);

  const onItemCheck = (enumType: number, inputLabel?: string) => {
    setAllToStateName([
      ...transactionForSelectList({
        enumType,
        statusId: inputLabel,
        isEditMode: setEditModal,
        userState,
        transactionList,
        stateNodeList,
      }),
    ]);
  };

  // useEffect(() => {
  //   if (incidentForm && incidentForm.attachments && incidentForm?.attachments.length !== 0) {
  //     setAttachments([...incidentForm?.attachments]);
  //   }
  // }, [incidentForm]);

  useEffect(() => {
    const attach = form.getFieldValue('attachments');
    if (attach && attach?.length !== 0) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        attachments,
      });
      // if (incidentDataInForm && incidentDataInForm.attachments !== undefined) {
      //   // incidentDataInForm.attachments = attachments;
      //   setIncidentDataInForm({ ...incidentDataInForm, attachments });
      // }
    }
  }, [attachments]);

  useEffect(() => {
    if (kanban) {
      let taskForFieldId = [];
      if (fieldsList) {
        taskForFieldId = fieldsList.filter((obj) => obj.fieldsType === 17 && obj.id === incidentForm?.id);
        taskForFieldId = taskForFieldId.map((e) => e.id);
        setFieldsId(taskForFieldId);
      }
    } else {
      let incidentForFieldId = [];
      if (fieldsList) {
        incidentForFieldId = fieldsList.filter((obj) => obj.fieldsType === 3 && obj.id === incidentForm?.id);
        incidentForFieldId = incidentForFieldId.map((e) => e.id);
        setFieldsId(incidentForFieldId);
      }
    }
  }, [fieldsList]);

  const getLogsData = async () => {
    try {
      const logData = await logsService.lookupLogs({
        fieldIds: fieldsId.length > 0 ? fieldsId : undefined,
        blockSpinner: true,
      });

      const tempLog: LogsData[] = [];
      logData.data.rows.forEach((obj, index) => {
        const detail = obj.description;

        const match = detail.match(/has been\s+(\w+)/i);
        const actionWord = match?.[1]?.toLowerCase();

        const action =
          actionWord === 'created'
            ? 'CREATE'
            : actionWord === 'updated'
            ? 'UPDATE'
            : actionWord === 'deleted'
            ? 'DELETE'
            : 'Unknown';

        const username = usersList.find((e) => e.id === obj.createdById)?.userName || '-';

        tempLog.push({
          key: index,
          user: username,
          action,
          details: detail,
          timestamp: moment(obj.createdAt).format('HH:mm DD/MM/YYYY'),
        });
      });
      setLogsData(tempLog);

      // dispatch(contentsActions.incidentFolderList(incidentFolderData.data.rows));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (fieldsId.length > 0) {
      getLogsData();
    }
  }, [fieldsId, usersList, incidentList]);

  const onFormSave = async (values: any) => {
    setIsLoading(true);
    if (setEditModal) {
      try {
        if (kanban) {
          const ccrIds: string[] = [];
          const ttIds: string[] = [];
          let primaryRequirementType = '';
          const primaryRequirementObj = initialCcrTtList.find((obj) => obj.id === values.primaryRequirementId);

          if (primaryRequirementObj) {
            primaryRequirementType = 'ccrId' in primaryRequirementObj ? 'CCR' : 'TT';
          }

          if (values.requirements) {
            ccrTtList.forEach((element) => {
              if (values.requirements.includes(element.id)) {
                if ('ccrId' in element) {
                  ccrIds.push(element.id);
                } else {
                  ttIds.push(element.id);
                }
              }
            });
          }

          const { ccrTT, ...restValues } = values;

          const editTaskFormValues = {
            ...restValues,
            primaryRequirementType,
            ccrIds,
            ttIds,
          };

          const taskUpdateData = await taskService.taskEdit({
            ...editTaskFormValues,
            id: incidentForm.id,
            deletedAttachments: deletedStringAttachments,
          });

          setAddIncidentModal(false);
          form.setFieldsValue(defaultTaskData);
          dispatch(contentsActions.taskEdited(taskUpdateData.data));
        } else {
          const editIncidentData = {
            ...values,
            possibleCommandIds,
            id: incidentForm.id,
            deletedAttachments: deletedStringAttachments,
            notIncludedActionIds,
          };

          const incidentUpdateData = await incidentService.incidentEdit(editIncidentData);

          setAddIncidentModal(false);
          form.setFieldsValue(defaultIncidentData);
          dispatch(contentsActions.incidentEdited(incidentUpdateData.data));

          const relatedActions = actionList.filter((action) => action.incidentNumberId === incidentForm.id);

          relatedActions.forEach((action) => {
            if (!notIncludedActionIds.includes(action.id)) {
              if (possibleCommandIds.length) {
                const filteredCommands =
                  action.emir && action.emir.filter((emir) => possibleCommandIds.includes(Number(emir)));

                dispatch(
                  contentsActions.actionEdited({
                    ...action,
                    emir: filteredCommands,
                  }),
                );
              } else {
                dispatch(
                  contentsActions.actionEdited({
                    ...action,
                    emir: [],
                  }),
                );
              }
            }
          });
        }
        displaySuccessStatusMessage(t('success.edited'));
        setOnClickOpen(false);
      } catch (error: any) {
        console.log(error);
        if (error !== errorLocals.errorHandledError) {
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    } else {
      try {
        if (kanban) {
          const ccrIds: string[] = [];
          const ttIds: string[] = [];
          let primaryRequirementType = '';
          const primaryRequirementObj = initialCcrTtList.find((obj) => obj.id === values.primaryRequirementId);

          if (primaryRequirementObj) {
            primaryRequirementType = 'ccrId' in primaryRequirementObj ? 'CCR' : 'TT';
          }

          if (values.requirements) {
            ccrTtList.forEach((element) => {
              if (values.requirements.includes(element.id)) {
                if ('ccrId' in element) {
                  ccrIds.push(element.id);
                } else {
                  ttIds.push(element.id);
                }
              }
            });
          }

          const { ccrTT, ...restValues } = values;

          const createTaskFormValues = {
            ...restValues,
            primaryRequirementType,
            ccrIds,
            ttIds,
          };

          const taskAddData = await taskService.createTask(createTaskFormValues, {
            blockErrorHandler: true,
          });
          form.setFieldsValue(defaultTaskData);
          setAddIncidentModal(false);
          dispatch(contentsActions.taskAdded(taskAddData.data));
          dispatch(contentsActions.fieldListAdd({ id: taskAddData.data.id, fieldsType: 17 }));
        } else {
          const createIncidentData = {
            ...values,
            possibleCommandIds,
            notIncludedActionIds,
          };

          const incidentAddData = await incidentService.createIncident(createIncidentData, {
            blockErrorHandler: true,
          });
          form.setFieldsValue(defaultIncidentData);
          setAddIncidentModal(false);
          // setIncidentDataInForm(defaultIncidentData);
          dispatch(contentsActions.incidentAdded(incidentAddData.data));
          dispatch(contentsActions.fieldListAdd({ id: incidentAddData.data.id, fieldsType: 3 }));
        }

        displaySuccessStatusMessage(t('success.added'));
        setOnClickOpen(false);
      } catch (error) {
        console.log(error);
        if (error !== errorLocals.errorHandledError) {
          // @ts-ignore
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    }
    setModalInEditMode(false);
    setIsLoading(false);
  };

  useEffect(() => {
    const tempArray: any[] = [];
    if (attachments === null) {
      setAttachments([]);
    } else {
      attachments?.forEach((element: any) => {
        if (element.url) {
          tempArray.push({
            name: element.file.name,
            size: element.file.size,
            uploadedAt: element.file.lastModifiedDate,
            path: '',
            mediaType: element.file.type,
          });
        } else {
          tempArray.push(element);
        }
      });
      setGeneratedAttachsForFileTable(tempArray);
    }
  }, [attachments]);

  const handleOnChangeUploadInput = async (
    onChangeInputEvent: React.ChangeEvent<HTMLInputElement>,
    index: number | undefined = undefined,
  ) => {
    const getUploadInput = await attachmentHelper.handleOnChangeUploadInput(
      onChangeInputEvent,
      index,
      attachments,
      preferredLanguage,
      t,
    );

    if (getUploadInput?.newImages) {
      setAttachments(getUploadInput.newImages);
    }
    // setReplacedImageIndexes([...replacedImageIndexes, ...getUploadInput?.currentReplacedIndexes]);
  };

  const deleteAttachment = (attachment: any) => {
    if (attachment.url) {
      setAttachments(attachments.filter((atth: any) => atth !== attachment));
    } else {
      setAttachments(attachments.filter((atth: any) => atth !== attachment));
      setDeletedStringAttachments([...deletedStringAttachments, attachment.path]);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...incidentForm,

      units: incidentForm.units.map((value: string | MapUnit | bigint) => {
        return (value as MapUnit).kisaIsim;
      }),
    });
  }, [incidentForm]);

  useEffect(() => {
    const startDateTimeGroup = form.getFieldValue('startDateTimeGroup');
    const endDateTimeGroup = form.getFieldValue('endDateTimeGroup');

    if (!endDateTimeGroup) {
      form.setFieldsValue({
        endDateTimeGroup: startDateTimeGroup,
      });
    }
  }, [form.getFieldValue('startDateTimeGroup')]);

  useEffect(() => {
    const startDateTimeGroup = form.getFieldValue('startDateTimeGroup');
    const endDateTimeGroup = form.getFieldValue('endDateTimeGroup');

    if (moment(endDateTimeGroup).valueOf() < moment(startDateTimeGroup).valueOf()) {
      form.setFieldsValue({
        endDateTimeGroup: startDateTimeGroup,
      });
    }
  }, [form.getFieldValue('endDateTimeGroup')]);

  return (
    <>
      {onClickOpen && (
        <DraggableModal
          headerText={
            kanban
              ? setEditModal
                ? t('PPM.task.editTask')
                : t('PPM.task.addTask')
              : setEditModal
              ? `${t('FMM.incident.editIncident')} (${incidentName})`
              : `${t('FMM.incident.addIncident')} (${incidentName})`
          }
          onClickClose={() => setOnClickOpen(false)}
          style={{ width: '800px', height: '600px' }}
        >
          <Form
            initialValues={initialValues}
            onValuesChange={onValuesChange}
            onFinish={onFormSave}
            scrollToFirstError={{ behavior: 'smooth' }}
            form={form}
          >
            <div className="popup-main-container">
              <div className="popup-container">
                <div className="popup-content" style={{ padding: 0 }}>
                  <div className={styles.container} style={{ padding: 10, marginRight: 15 }}>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.event')}</span>
                      <Form.Item>
                        <Input className={styles.standard_input} value={eventName} disabled />
                      </Form.Item>
                    </div>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">
                            {!kanban
                              ? t('FMM.incidentFolder.incidentFolderNumber')
                              : t('PPM.workPackage.workPackageNumber')}
                          </span>
                          <Form.Item
                            name={!kanban ? 'incidentFolderNumberId' : 'workPackageNumberId'}
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Select
                              className={styles.select}
                              showSearch
                              placeholder={
                                !kanban ? '"Select an incident folder number"' : 'Select a work package number'
                              }
                              optionFilterProp="children"
                              style={{ width: '645px' }}
                            >
                              {!kanban
                                ? incidentFolderList.map((option) => (
                                    <option
                                      value={option.id}
                                    >{`${option.incidentFolderNumber} - ${option.incidentFolderName}`}</option>
                                  ))
                                : workPackageList.map((option) => (
                                    <option value={option.id}>
                                      {`${option.workPackageNumber}, ${option.workPackageName}`}
                                    </option>
                                  ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <Button
                            className={styles.add_button}
                            disabled={checkPermissionList(PermissionEnum.IncidentFolderCreate)}
                            onClick={() => handleClickIncidentFolder()}
                          >
                            {t('general.add')}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">
                            {!kanban ? t('FMM.incident.incidentNumber') : t('PPM.task.taskNumber')}
                          </span>
                          <Form.Item
                            name={!kanban ? 'incidentNumber' : 'taskNumber'}
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Input className={styles.standard_input} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">
                            {!kanban ? t('FMM.incident.incidentName') : t('PPM.task.taskName')}
                          </span>
                          <Form.Item
                            name={!kanban ? 'incidentName' : 'taskName'}
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Input className={styles.standard_input} />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    {!kanban && (
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('general.units')}</span>
                        <Form.Item
                          name="units"
                          valuePropName="value"
                          rules={[{ required: false, message: t('general.required') || '' }]}
                        >
                          <Select
                            showArrow
                            showSearch
                            className={styles.select}
                            placeholder={t('general.selectUnits')}
                            optionFilterProp="label"
                            mode="multiple"
                            maxTagCount="responsive"
                          >
                            {units.map((option) => (
                              <option key={option.id.toString()} value={option.kisaIsim} label={option.kisaIsim}>
                                {option.kisaIsim}
                              </option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                    {!kanban ? (
                      <div className="popup-row grid-col-2-fixed">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('general.primaryTrainingObjectiveId')}</span>
                          <Form.Item
                            name="primaryTrainingObjectiveId"
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Select
                              className={styles.select}
                              showSearch
                              placeholder="Select a primary objective"
                              optionFilterProp="children"
                              style={{ width: '645px' }}
                            >
                              {trainingObjectiveList.map((option) => (
                                <option value={option.id}>{option.trainingObjective}</option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="popup-input-container">
                          <Button
                            className={styles.add_button}
                            disabled={checkPermissionList(PermissionEnum.ObjectiveCreate)}
                            onClick={() => handleClickTrainigObjective()}
                          >
                            {t('general.add')}
                          </Button>
                        </div>

                        <div className="popup-row">
                          <div className="popup-input-container">
                            <span className="popup-input-title">{t('general.secondaryTrainingObjective')}</span>
                            <Form.Item
                              name="secondaryTrainingObjective"
                              rules={[{ required: false, message: t('general.required') || '' }]}
                            >
                              <Select
                                className={styles.select}
                                showSearch
                                mode="multiple"
                                showArrow
                                optionFilterProp="children"
                                maxTagCount="responsive"
                                style={{ width: '645px' }}
                              >
                                {trainingObjectiveList
                                  .filter((option) => option.id !== form.getFieldValue('primaryTrainingObjectiveId'))
                                  .map((option) => (
                                    <option value={option.id}>{option.trainingObjective}</option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div className="popup-row">
                          <div className="popup-input-container">
                            <Button
                              className={styles.add_button}
                              disabled={checkPermissionList(PermissionEnum.ObjectiveCreate)}
                              onClick={() => handleClickTrainigObjective()}
                            >
                              {t('general.add')}
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('PPM.task.primaryRequirementId')}</span>
                          <Form.Item name="primaryRequirementId">
                            <Select
                              className={styles.select}
                              showSearch
                              showArrow
                              // placeholder="Select a CCR or TT"
                              optionFilterProp="children"
                              maxTagCount="responsive"
                              style={{ width: '100%' }}
                              allowClear
                            >
                              {initialCcrTtList.map((option) => {
                                if ('ccrId' in option) {
                                  return <option value={option.id}>{`${option.ccrId}, ${option.name}`}</option>;
                                } else {
                                  return <option value={option.id}>{`${option.ttId}, ${option.name}`}</option>;
                                }
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('PPM.task.secondaryRequirements')}</span>
                          <Form.Item name="requirements">
                            <Select
                              className={styles.select}
                              showSearch
                              mode="multiple"
                              showArrow
                              // placeholder="Select CCR or / and TT"
                              optionFilterProp="children"
                              maxTagCount="responsive"
                              style={{ width: '100%' }}
                              allowClear
                            >
                              {ccrTtList.map((option) => {
                                if ('ccrId' in option) {
                                  return <option value={option.id}>{`${option.ccrId}, ${option.name}`}</option>;
                                } else {
                                  return <option value={option.id}>{`${option.ttId}, ${option.name}`}</option>;
                                }
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    )}

                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('general.startDateTimeGroup')}</span>
                          <Form.Item
                            name="startDateTimeGroup"
                            rules={[{ type: 'object', required: true, message: t('general.required') || '' }]}
                            // valuePropName={'date'}
                          >
                            <CustomDatePicker style={{ width: '100%', marginTop: '10px' }} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('general.endDateTimeGroup')}</span>
                          <Form.Item
                            name="endDateTimeGroup"
                            rules={[{ type: 'object', required: true, message: t('general.required') || '' }]}
                            // valuePropName={'date'}
                          >
                            <CustomDatePicker style={{ width: '100%', marginTop: '10px' }} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('general.relatedAudienceEntities')}</span>
                          <Form.Item
                            name="relatedAudienceEntities"
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Select
                              showSearch
                              className={styles.select}
                              mode="multiple"
                              showArrow
                              optionFilterProp="children"
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Player_Audience_Entity)
                                .map((option) => (
                                  <option value={option.id}>{option.abbreviation}</option>
                                ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container">
                          <span className="popup-input-title">{t('general.relatedAudienceProcesses')}</span>
                          <Form.Item
                            name="relatedAudienceProcesses"
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Select
                              showSearch
                              className={styles.select}
                              mode="multiple"
                              showArrow
                              optionFilterProp="children"
                            >
                              {ontologies
                                .filter((obj) => Number(obj.ontologyType) === OntologyEnum.Training_Audience_Process)
                                .map((option) => (
                                  <option value={option.id}>{option.abbreviation}</option>
                                ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-row">
                        <div className="popup-input-container-private">
                          <span className="popup-input-title">{t('general.scenarioConditions')}</span>
                          <Form.Item
                            name="scenarioConditions"
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Input className={styles.standard_input} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container-private">
                          <span className="popup-input-title">{t('general.status')}</span>
                          <Form.Item
                            name="scenarioConditionStatus"
                            rules={[{ required: false, message: t('general.required') || '' }]}
                          >
                            <Select
                              className={styles.select}
                              showSearch
                              placeholder="Select a  scenario conditions status"
                              optionFilterProp="children"
                              style={{ width: '100%' }}
                              onDropdownVisibleChange={(visible) => {
                                if (visible)
                                  onItemCheck(
                                    flowOMMEnums.SCENARIO_CONDITION,
                                    form.getFieldValue('scenarioConditionStatus'),
                                  );
                                else fillExistState();
                              }}
                            >
                              {allToStateName.map((option) => {
                                if (option.enum === flowOMMEnums.SCENARIO_CONDITION || !option.enum) {
                                  return (
                                    <Select.Option key={option.id} value={option.id}>
                                      {option.stateName}
                                    </Select.Option>
                                  );
                                }
                              })}
                              {/* {stateNodeList.map((node) => (
                                <option value={node.id}>{node.stateName}</option>
                              ))} */}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container-private">
                          <span className="popup-input-title">{t('general.milConditions')}</span>
                          <Form.Item
                            name="milConditions"
                            rules={[{ required: true, message: t('general.required') || '' }]}
                          >
                            <Input className={styles.standard_input} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="popup-row">
                        <div className="popup-input-container-private">
                          <span className="popup-input-title">{t('general.status')}</span>
                          <Form.Item
                            name="milConditionStatus"
                            rules={[{ required: false, message: t('general.required') || '' }]}
                          >
                            <Select
                              className={styles.select}
                              showSearch
                              placeholder="Select a mil condition status"
                              optionFilterProp="children"
                              style={{ width: '100%' }}
                              onDropdownVisibleChange={(visible) => {
                                if (visible)
                                  onItemCheck(flowOMMEnums.MIL_CONDITION, form.getFieldValue('milConditionStatus'));
                                else fillExistState();
                              }}
                            >
                              {allToStateName.map((option) => {
                                if (option.enum === flowOMMEnums.MIL_CONDITION || !option.enum) {
                                  return (
                                    <Select.Option key={option.id} value={option.id}>
                                      {option.stateName}
                                    </Select.Option>
                                  );
                                }
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.description')}</span>
                      <Form.Item name="description" rules={[{ required: false, message: t('general.required') || '' }]}>
                        <TextArea autoSize={{ minRows: 3, maxRows: 10 }} showCount maxLength={2048} />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.log')}</span>
                      <Form.Item name="log">
                        <Logs logsData={logsData} />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.comment')}</span>
                      <Form.Item name="comment" rules={[{ required: false, message: t('general.required') || '' }]}>
                        <TextArea rows={3} showCount maxLength={256} />
                      </Form.Item>
                    </div>

                    <div className={styles.attachmentsTitle}>
                      <Form.Item name={'attachments'}>
                        <Button
                          className={'attachment'}
                          onClick={() => fileInputRef.current.click()}
                          disabled={attachments?.length > 2}
                          icon={<UploadOutlined style={{ marginInlineEnd: '5px' }} />}
                          type="primary"
                        >
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none', fontSize: 12 }}
                            onChange={(e) => handleOnChangeUploadInput(e)}
                          />
                          {t('general.addAttachment')}
                        </Button>
                      </Form.Item>
                    </div>

                    <FileTable
                      dataSrc={generatedAttachsForFileTable}
                      deleteRow={deleteAttachment}
                      attachments={attachments}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-footer" style={{ marginRight: '7%', marginTop: '2%' }}>
              <div>
                <Button className={styles.nextButton} loading={isLoading} htmlType="submit">
                  {t('general.save')}
                </Button>
                <button className="modal-button" onClick={() => setOnClickOpen(false)} type="button">
                  {t('general.cancel')}
                </button>
              </div>
            </div>
          </Form>
        </DraggableModal>
      )}

      {addIncidentFolderModal && (
        <IncidentFolderForm
          incidentFolderFormAddData={incidentFolderDataForm}
          onClickOpen
          setEditModal={modalInEditMode}
          setOnClickOpen={() => setAddIncidentFolderModal(false)}
        />
      )}
      {addWorkPackageModal && (
        <IncidentFolderForm
          workPackageFormAddData={workPackageDataForm}
          onClickOpen
          setEditModal={modalInEditMode}
          setOnClickOpen={() => setAddWorkPackageModal(false)}
        />
      )}

      {addTrainigObjectiveModal && (
        <TrainingObjectiveForm
          trainingObjectiveForm={trainingObjectiveDataForm}
          onClickOpen
          isEditMode={modalInEditMode}
          setOnClickOpen={() => setAddTrainigObjectiveModal(false)}
        />
      )}
    </>
  );
};

export default IncidentForm;
